<template>
  <entity-edit-form
    :title="title"
    :data-service="dataService"
    :create-entity="isCreate"
    :fields="fields"
    :list-route-name="listRouteName"
    :item-id="this.$route.params.id"
  />
</template>

<script>
  import EntityEditForm from '@/components/ui/crud/EntityEditForm'
  import OrganizationDataService from '@/services/api/OrganizationDataService'
  // import TextField from '@/components/ui/crud/fields/TextField'
  import { VCheckbox, VTextField } from 'vuetify/lib'

  export default {
    components: { EntityEditForm },
    data () {
      return {
        title: 'Создание организации (юр-лица)',
        isCreate: true,
        listRouteName: 'organizationsList',
        dataService: OrganizationDataService,
        fields: [
          { key: 'name', label: 'Название', component: VTextField, defaultValue: null, rules: ['required'] },
          { key: 'jupiterName', label: 'Название в Юпитер', component: VTextField, rules: [], defaultValue: null },
          { key: 'inn', label: 'ИНН', component: VTextField, defaultValue: null },
          { key: 'kpp', label: 'КПП', component: VTextField, defaultValue: null },
          { key: 'phone', label: 'Телефон', component: VTextField, defaultValue: null },
          { key: 'email', label: 'Email', component: VTextField, defaultValue: null, rules: ['email'] },
          { key: 'status', label: 'Организация активна (статус)', component: VCheckbox, defaultValue: true },
        ],
      }
    },

  }
</script>
